<template>
  <div class="operation-text">
    <div class="badge">
      <VBadge
        :appearance="isVonageBrand ? 'subtle' : 'duotone'"
        shape="pill"
        dense
        :text="method.toUpperCase()"
        :connotation="vwcBadgesConnotations[method]"
      />
    </div>
    <div>
      <link-wrapper class="header-anchor" :href="`#${id}`">
        {{ summary }}
      </link-wrapper>
    </div>
  </div>
</template>
<script setup lang="ts">
import { VBadge } from '@vonage/vivid-vue';
import LinkWrapper from '@/components/markdown/widgets/LinkWrapper.vue';
import { isVonageBrand } from '@/constants';

defineProps({
  method: { type: String, required: true },
  id: { type: String, required: true },
  summary: { type: String, required: true },
});

const vwcBadgesConnotations = { get: 'information', post: 'success', delete: 'alert', patch: 'success', put: 'cta' };
</script>
<style scoped lang="scss">
@import '../../../../styles/variables/media.scss';

.operation-text {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 0.14fr 1fr;

  @media screen and (max-width: $laptop) {
    grid-auto-columns: 10% 100%;
  }
  @media screen and (max-width: $tablet) {
    grid-auto-columns: 30% 70%;
  }

  @media screen and (max-width: $mobile-medium) {
    grid-auto-columns: 50% 50%;
  }
}
.badge {
  font-size: 12px;
  word-break: break-all;
  display: flex;
}
</style>
